export default
{
    name: 'app-cta',

    props:
    {
        label:
        {
            type: String,
            default: ''
        },
        href:
        {
            type: String,
            default: null
        }
    },

    computed:
    {
        wordsRegular()
        {
            const labelSplitted = this.label.split('<b>')
            const words = []

            for (let i = 0; i < labelSplitted.length; i += 1)
            {
                if (i < labelSplitted.length - 1)
                {
                    words.push(labelSplitted[i].replace(/ /g, ''))
                }
            }

            return words
        },

        wordsBold()
        {
            const labelSplitted = this.label.split('<b>')

            return `<b>${labelSplitted[labelSplitted.length - 1]}`
        }
    },

    created()
    {
        // Events
        this.eventHub.$on('window:resize', this._onResize)
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('window:resize', this._onResize)
    },

    methods:
    {
        // Events
        _onResize()
        {
            // do something
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-cta/script.js